import type { SyntheticEvent } from 'react';

/** レイヤー削除ボタン（二段階タップ。シート削除の confirming と同様） */

export const LAYER_REMOVE_BTN_CLASS = 'layer-remove-btn';

const CONFIRMING_MS = 2000;

let keyboardRemoveLayerId: string | null = null;
let keyboardRemoveTimer: number | null = null;

function clearKeyboardLayerRemoveState(): void {
  keyboardRemoveLayerId = null;
  if (keyboardRemoveTimer != null) {
    window.clearTimeout(keyboardRemoveTimer);
    keyboardRemoveTimer = null;
  }
}

function setLayerRemoveConfirmingForId(layerId: string): void {
  document
    .querySelectorAll(`.${LAYER_REMOVE_BTN_CLASS}[data-layer-id="${layerId}"]`)
    .forEach(el => el.classList.add('confirming'));
}

export function clearLayerRemoveConfirming(): void {
  clearKeyboardLayerRemoveState();
  document.querySelectorAll(`.${LAYER_REMOVE_BTN_CLASS}.confirming`).forEach(el => {
    el.classList.remove('confirming');
  });
}

/** Alt+− 二段階削除（削除ボタンと同じ 2 秒タイマー） */
export function handleKeyboardLayerRemove(
  layerId: string,
  canRemove: boolean,
  onRemove: (layerId: string) => void
): void {
  if (!canRemove) return;

  if (keyboardRemoveLayerId === layerId) {
    clearLayerRemoveConfirming();
    onRemove(layerId);
    return;
  }

  clearLayerRemoveConfirming();
  keyboardRemoveLayerId = layerId;
  setLayerRemoveConfirmingForId(layerId);
  keyboardRemoveTimer = window.setTimeout(() => {
    if (keyboardRemoveLayerId === layerId) {
      document
        .querySelectorAll(`.${LAYER_REMOVE_BTN_CLASS}[data-layer-id="${layerId}"]`)
        .forEach(el => el.classList.remove('confirming'));
    }
    clearKeyboardLayerRemoveState();
  }, CONFIRMING_MS);
}

export function handleLayerRemoveButtonClick(
  e: SyntheticEvent,
  layerId: string,
  onRemove: (layerId: string) => void
): void {
  e.stopPropagation();
  if ('touches' in e) {
    e.preventDefault();
  }

  const btn = e.currentTarget as HTMLElement;

  if (btn.classList.contains('confirming')) {
    btn.classList.remove('confirming');
    onRemove(layerId);
    return;
  }

  clearLayerRemoveConfirming();
  btn.classList.add('confirming');
  window.setTimeout(() => {
    btn.classList.remove('confirming');
  }, CONFIRMING_MS);
}
